import { Resources, useResource } from "Infrastructure/Translation/Resources";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@mui/material";
import type { FC } from "react";

type ModalProps = {
	isOpen: boolean;
	handleClose: () => void;
	onSubmit: () => void;
	isPending?: boolean;
};

const orderSetupResource = Resources.base.orderSetup.shared;

export const DeleteSetupModal: FC<ModalProps> = ({
	isOpen,
	handleClose,
	onSubmit,
	isPending,
}) => {
	const { t } = useResource();

	const handleSubmit = () => {
		onSubmit();
		handleClose();
	};

	return (
		<Dialog open={isOpen} onClose={handleClose}>
			<DialogTitle>{t(orderSetupResource.confirmationTitle)}</DialogTitle>
			<DialogContent>
				<Typography>{t(orderSetupResource.deleteConfirmation)}</Typography>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={handleClose}>
					{t(orderSetupResource.cancel)}
				</Button>
				<Button
					variant="contained"
					color="error"
					onClick={handleSubmit}
					loading={isPending}
				>
					{t(orderSetupResource.deleteSetup)}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
